// extracted by mini-css-extract-plugin
module.exports = {"element":"sortable-elements_element__2CV6M","sorter":"sortable-elements_sorter__6uHxz","action":"sortable-elements_action__3dNEh","formitem":"sortable-elements_formitem__399QT"};